import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/logo.png';

const _withScopeId = n => (_pushScopeId("data-v-e14b5baa"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header-wrap"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "logo-icon"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/",
  target: "_blank"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})])])], -1));

const _hoisted_3 = {
  class: "topnav"
};
const _hoisted_4 = {
  class: "header-right"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("AIGC");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("上传资源");

const _hoisted_7 = {
  class: "el-dropdown-link"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("我的主页");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("我的AIGC");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("登录二维码");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("采集说明");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("入门手册");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("退出");

import { computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Plus } from "@element-plus/icons-vue";
import TopNav from "./TopVav.vue";
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const store = useStore();
    const router = useRouter(); // 计算属性：判断是否显示 AIGC 按钮

    const showAIGCButton = computed(() => {
      const modules = store.state.login.userInfo.modules || []; // 检查是否包含 aigcImg2model 或 aigcText2model 模块

      return modules.includes("aigcImg2model") || modules.includes("aigcText2model");
    });

    const handleCommand = command => {
      if (command === "logout") {
        console.log("hahah");
        store.dispatch("login/logout").then(res => {
          console.log("注销", res);
          window.location.replace("/login");
        });
      } else if (command === "home") {
        console.log("我的主页");
        router.push("/home");
      } else if (command === "qrcode") {
        router.push("/home/qrcode");
      } else if (command === "aigc") {
        console.log("我的aigc");
        router.push("/aigc/home/model");
      } else if (command === "collect") {
        console.log("采集说明"); // router.push("/home/collect");

        window.open("https://www.yuque.com/xrverse-e6ryv/mwygn8/yvxi472rx79fysn7?singleDoc", "_blank");
      } else if (command === "manual") {
        console.log("入门手册"); //window.location.href = '';

        window.open("https://www.yuque.com/xrverse-e6ryv/mwygn8/ab6q4grk6xvxkn9y?singleDoc", "_blank");
      }
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_icon_arrow_down = _resolveComponent("icon-arrow-down");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      const _component_el_space = _resolveComponent("el-space");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(TopNav)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_space, null, {
        default: _withCtx(() => [_unref(showAIGCButton) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          text: "",
          icon: _unref(Plus),
          style: {
            "--el-button-bg-color": "rgba(255, 255, 255, 0.2)"
          },
          onClick: _cache[0] || (_cache[0] = () => _unref(router).push('/aigc/assets/upload'))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }, 8, ["icon"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          text: "",
          icon: _unref(Plus),
          style: {
            "--el-button-bg-color": "rgba(255, 255, 255, 0.2)"
          },
          onClick: _cache[1] || (_cache[1] = () => _unref(router).push('/assets/upload'))
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_dropdown, {
          onCommand: handleCommand
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              command: "home"
            }, {
              default: _withCtx(() => [_hoisted_8]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              command: "aigc"
            }, {
              default: _withCtx(() => [_hoisted_9]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              command: "qrcode"
            }, {
              default: _withCtx(() => [_hoisted_10]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              command: "collect"
            }, {
              default: _withCtx(() => [_hoisted_11]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              command: "manual"
            }, {
              default: _withCtx(() => [_hoisted_12]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              divided: "",
              command: "logout"
            }, {
              default: _withCtx(() => [_hoisted_13]),
              _: 1
            })]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createTextVNode(_toDisplayString(_unref(store).state.login.userInfo.realName) + " ", 1), _createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_component_icon_arrow_down)]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      })])]);
    };
  }

});